import { MovimientoBancarioReadingDtoProps } from "api/DTOs/MovimientoBancarioReadingDto"
import { ColoredNumber } from "features/Contabilidad/components/ColoredNumber"
import { TFunction } from "i18next"
import { frontendCurrency } from "utils/formatCurrency"
import { frontendDateFormat } from "utils/formatDate"
import { ConceptoField } from "./components/ConceptoField"
import { DisabledField } from "./components/DisabledField"

export const MOVIMIENTO_BANCARIO_STATUS = {
  CONSOLIDADO: 1,
  PENDIENTE: 2,
}
interface MovimientosBancariosColumnsProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onRenderNoteIcon: $TSMigrationFixMe
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onRenderCoincidenciasMovimientos: $TSMigrationFixMe
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onRenderConceptos: $TSMigrationFixMe
  t: TFunction
}

export const MOVIMIENTOS_BANCARIOS_COLUMNS = ({
  onRenderNoteIcon,
  onRenderCoincidenciasMovimientos,
  onRenderConceptos,
  t,
}: MovimientosBancariosColumnsProps) => {
  const columns = [
    {
      key: "fechaOperacion",
      header: `${t("bancos.idView.table.operationHeaderDate")}`,
      field: "fechaOperacion",
      body: ({ fecha, status }: MovimientoBancarioReadingDtoProps) => {
        return fecha
          ? DisabledField({
              isDisabled: status?.id === MOVIMIENTO_BANCARIO_STATUS.PENDIENTE,
              className: "tw-py-3 tw-pl-10 tw-pr-3",
              children: frontendDateFormat(new Date(fecha)),
            })
          : "-"
      },
      style: { width: "10%" },
      sortable: true,
      sortField: "BookingDate",
      className: "!tw-p-0 !tw-h-8",
    },
    {
      key: "fechaValor",
      header: `${t("bancos.idView.table.headerDate")}`,
      field: "fechaValor",
      body: ({ fechaValor, status }: MovimientoBancarioReadingDtoProps) =>
        fechaValor
          ? DisabledField({
              isDisabled: status?.id === MOVIMIENTO_BANCARIO_STATUS.PENDIENTE,
              children: frontendDateFormat(new Date(fechaValor)),
            })
          : "-",
      style: { width: "10%" },
      sortable: true,
      sortField: "ValueDate",
      className: "!tw-p-0 !tw-h-8",
    },
    {
      key: "descripcionMov",
      field: "descripcionMov",
      header: `${t("bancos.idView.table.haederDescription")}`,
      sorter: true,
      body: (rowData: MovimientoBancarioReadingDtoProps) =>
        rowData?.concepto
          ? ConceptoField({
              isDisabled:
                rowData?.status?.id === MOVIMIENTO_BANCARIO_STATUS.PENDIENTE,
              children: onRenderConceptos(rowData),
            })
          : "-",
      style: { width: "40%" },
      sortable: true,
      sortField: "Description",
      className: "!tw-p-0 !tw-h-8",
    },
    {
      key: "coincidencia",
      field: "coincidencia",
      header: `${t("bancos.idView.table.headerMatch")}`,
      body: (rowData: MovimientoBancarioReadingDtoProps) => {
        return DisabledField({
          isDisabled:
            rowData?.status?.id === MOVIMIENTO_BANCARIO_STATUS.PENDIENTE,
          children: onRenderCoincidenciasMovimientos(rowData),
        })
      },
      className: "!tw-p-0 !tw-h-8",
    },
    {
      key: "importeCuenta",
      dataIndex: "importeCuenta",
      header: `${t("bancos.idView.table.headerImport")}`,
      bodyClassName: `tw-font-medium !tw-text-end`,
      body: ({ importe, status }: MovimientoBancarioReadingDtoProps) =>
        importe && !Number.isNaN(importe)
          ? DisabledField({
              isDisabled: status?.id === MOVIMIENTO_BANCARIO_STATUS.PENDIENTE,
              className: "tw-justify-end",
              children: ColoredNumber(importe),
            })
          : "-",
      style: { width: "10%" },
      alignCol: "right",
      sortable: true,
      sortField: "Amount",
      className: "!tw-p-0 !tw-h-8",
    },
    {
      key: "balanceActual",
      field: "balanceActual",
      body: ({ balanceActual, status }: MovimientoBancarioReadingDtoProps) =>
        balanceActual && !Number.isNaN(balanceActual)
          ? DisabledField({
              isDisabled: status?.id === MOVIMIENTO_BANCARIO_STATUS.PENDIENTE,
              className: "tw-justify-end",
              children: frontendCurrency(balanceActual),
            })
          : "-",
      header: `${t("bancos.idView.table.headerBalance")}`,
      sorter: true,
      bodyClassName: `!tw-text-end`,
      alignCol: "right",
      style: { width: "10%" },
      sortable: true,
      sortField: "Balance",
      className: "!tw-p-0 !tw-h-8",
    },
    {
      key: "iconBancos",
      body: (rowData: MovimientoBancarioReadingDtoProps) => {
        return DisabledField({
          isDisabled:
            rowData?.status?.id === MOVIMIENTO_BANCARIO_STATUS.PENDIENTE,
          className: "tw-justify-center",
          children: onRenderNoteIcon(rowData),
        })
      },
      bodyClassName: `!tw-text-center`,
      style: { width: "5%" },
      className: "!tw-p-0 !tw-h-8",
    },
  ]

  return columns
}
